import { render, staticRenderFns } from "./WholesaleInquires.vue?vue&type=template&id=2414a7e6&scoped=true&"
import script from "./WholesaleInquires.vue?vue&type=script&lang=js&"
export * from "./WholesaleInquires.vue?vue&type=script&lang=js&"
import style0 from "./WholesaleInquires.vue?vue&type=style&index=0&id=2414a7e6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2414a7e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VChip,VChipGroup,VCol,VDatePicker,VMenu,VRow,VTextField})
